


















































































import Currency from '@/components/Currency.vue';
import Pendiente from '@/models/Pendiente';
import Recibo from '@/models/Recibo';
import Comprobante from '@/models/Comprobante';
import Entidad from '@/models/Entidad.vue';
import { ElSwitch } from 'element-ui/types/switch';
export default {
	name: 'CuentaCorriente',
	inject: ['responsive'],
	components: {
		Currency,
	},
	data() {
		return {
			radio: 'Ninguno',
			dialogVisible: false,
			precio: '',
			rowselected: '',
		};
	},
	watch: {
		pendientesSelected(pendientesSelected) {
			if (pendientesSelected.length === 0) this.radio = 'Ninguno';
			else if (pendientesSelected.length === this.pendientesTable.length) this.radio = 'Todos';
			else if (JSON.stringify(pendientesSelected) === JSON.stringify(this.vencidosTable)) this.radio = 'Sólo vencidos';
			else this.radio = '';
		},
	},

	computed: {
		pendientesSelected(): Pendiente[] {
			return this.$store.state.recibos.pendientesSelected;
		},
		pendientesTable(): Pendiente[] {
			return this.$store.state.recibos.pendientesTable;
		},
		vencidosTable(): Pendiente[] {
			return this.$store.state.recibos.vencidosTable;
		},
		totalPendientesSelected() {
			return this.$store.state.recibos.totalPendientesSelected;
		},
	},
	filters: {},
	methods: {
		handleSelectionChange(selection: Pendiente) {
			this.$store.dispatch('savePendientesSelected', selection);
		},
		handleCellClick(row: Pendiente) {
			this.$refs.recibosTable.toggleRowSelection(row);
		},
		toggleSelection(rows: Pendiente[]) {
			this.$refs.recibosTable.clearSelection();
			if (rows) {
				rows.forEach(row => {
					this.$refs.recibosTable.toggleRowSelection(row, true);
				});
			}
		},
		clickEdit(row) {
			this.$prompt(
				'Cantidad a aplicar',
				`${row.descomp}  ${row.torig} ${row.norig} ($ ${this.$options.filters.toCurrency(
					parseFloat(row.importe_total) - parseFloat(row.importe_aplicado)
				)})`,
				{
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancelar',
					inputPlaceholder: '0,00',
					inputType: 'number',
					//id: 'currency',
					//inputMode: 'decimal',
					//inputPattern: '^\$\d{1,3}(.\d{3})*(\,\d+)?$',
					///inputPattern: /^-?[0-9]+([,][0-9]+)?$/,
					//inputErrorMessage: 'Importe inválido',
					center: this.responsive.isMobile,
					customClass: this.responsive.isMobile ? 'promp-mobile' : '',
				}
			)
				.then(({ value }) => {
					const max = parseFloat(row.importe_total) - parseFloat(row.importe_aplicado);
					if (Math.sign(max) === 1) {
						if (parseFloat(value) <= max) {
							this.$refs.recibosTable.toggleRowSelection(row, true);
							row.importe_saldo = parseFloat(value.replace(',', '.'));
							this.$store.dispatch('savePendientesSelected', this.pendientesSelected);
						} else {
							this.$message({
								type: 'error',
								message: 'El saldo a aplicar debe ser menor a $' + max,
							});
						}
					} else {
						if (parseFloat(value) >= max && parseFloat(value) < 0) {
							this.$refs.recibosTable.toggleRowSelection(row, true);
							row.importe_saldo = parseFloat(value.replace(',', '.'));
							this.$store.dispatch('savePendientesSelected', this.pendientesSelected);
						} else {
							this.$message({
								type: 'error',
								message: `El saldo a aplicar debe estar comprendido entre $ ${max} y cero`,
							});
						}
					}
				})
				.catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: 'Input canceled',
					// });
				});
		},
		inputValidator(value) {
			console.log('esta es value', value);
			const input = document.querySelector(`#currency`);
			function formatNumber(n) {
				// format number 1000000 to 1.234.567
				return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
			}
			// appends $ to value, validates decimal side
			// and puts cursor back in right position.
			// get input value
			var input_val = value;

			// don't validate empty input
			if (!input_val || input_val === '') return;

			// original length
			var original_len = input_val.length;

			// initial caret position
			// var caret_pos = medio.prop('selectionStart');

			// check for decimal
			if (input_val.indexOf(',') >= 0) {
				var decimal_pos = input_val.indexOf(',');
				// split number by decimal point
				var left_side = input_val.substring(0, decimal_pos);
				var right_side = input_val.substring(decimal_pos);
				// add commas to left side of number
				left_side = formatNumber(left_side);
				// validate right side
				right_side = formatNumber(right_side);
				// Limit decimal to only 2 digits
				right_side = right_side.substring(0, 2);
				// join number by .
				input_val = '$' + left_side + ',' + right_side;
			} else {
				input_val = formatNumber(input_val);
				input_val = '$' + input_val;
			}
			console.log('input_val', input_val);
			this.precio = input_val;
			//return input_val;
		},
		pressKey(event) {
			let key = event.key;
			if (key === 'Unidentified' || key === '.') {
				key = ',';
				this.precio += key;
			}
		},
		confirm() {
			const row = this.rowselected;
			console.log('esta es row', row);
			this.precio = this.precio.replace('$', '').replace(/\./g, '').replace(/,/g, '.');
			const max = parseFloat(row.importe_total) - parseFloat(row.importe_aplicado);
			if (Math.sign(max) === 1) {
				if (parseFloat(this.precio) <= max) {
					this.$refs.recibosTable.toggleRowSelection(row, true);
					row.importe_saldo = parseFloat(this.precio.replace(',', '.'));
					this.$store.dispatch('savePendientesSelected', this.pendientesSelected);
				} else {
					this.$message({
						type: 'error',
						message: 'El saldo a aplicar debe ser menor a $' + max,
					});
				}
			} else {
				if (parseFloat(this.precio) >= max && parseFloat(this.precio) < 0) {
					this.$refs.recibosTable.toggleRowSelection(row, true);
					row.importe_saldo = parseFloat(this.precio.replace(',', '.'));
					this.$store.dispatch('savePendientesSelected', this.pendientesSelected);
				} else {
					this.$message({
						type: 'error',
						message: `El saldo a aplicar debe estar comprendido entre $ ${max} y cero`,
					});
				}
			}
			this.rowselected = '';
			this.precio = '';
			this.dialogVisible = false;
		},
		tableRowClassName({ row, rowIndex }) {
			if (
				this.pendientesSelected.find((element: Pendiente) => element === row) &&
				parseFloat(row.importe_saldo) !== parseFloat(row.importe_total + row.importe_aplicado)
			)
				return 'bgSelect colorApli';
			else if (this.pendientesSelected.find((element: Pendiente) => element === row)) return 'bgSelect';
			else if (parseFloat(row.importe_saldo) !== parseFloat(row.importe_total + row.importe_aplicado)) return 'colorApli';
		},
		convertDate(inputFormat: string) {
			if (!inputFormat) return;
			function pad(s: number) {
				return s < 10 ? '0' + s : s;
			}
			const d = new Date(inputFormat);
			return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		},
		changeRadio(label: string) {
			if (label == 'Ninguno') this.$refs.recibosTable.clearSelection();
			if (label == 'Todos') {
				this.$refs.recibosTable.clearSelection();
				this.$refs.recibosTable.toggleAllSelection();
			}
			if (label == 'Sólo vencidos') {
				this.$refs.recibosTable.clearSelection();
				const hoy = this.convertDate(new Date());
				this.vencidosTable.forEach(element => this.$refs.recibosTable.toggleRowSelection(element, true));
			}
		},
	},
	mounted() {
		this.$store.dispatch('callPendientesTable');
	},
};
